
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models.ts'
export type * from './prismaNamespace.ts'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  Address: 'Address',
  User: 'User',
  Account: 'Account',
  Session: 'Session',
  AuditLog: 'AuditLog',
  OneTimePurchase: 'OneTimePurchase',
  AttributionBridge: 'AttributionBridge',
  VerificationToken: 'VerificationToken',
  ChatMessage: 'ChatMessage',
  Patient: 'Patient',
  Therapist: 'Therapist',
  MinorGuardianConsent: 'MinorGuardianConsent',
  MinorGuardianConsentInvite: 'MinorGuardianConsentInvite',
  Company: 'Company',
  TherapistDocument: 'TherapistDocument',
  TherapyRelationship: 'TherapyRelationship',
  AdditionalService: 'AdditionalService',
  TherapistReport: 'TherapistReport',
  TherapistReportCheckout: 'TherapistReportCheckout',
  UserReview: 'UserReview',
  SessionReview: 'SessionReview',
  TherapySession: 'TherapySession',
  GoogleCalendarAccess: 'GoogleCalendarAccess',
  WorkingHours: 'WorkingHours',
  Earning: 'Earning',
  Payout: 'Payout',
  Complaint: 'Complaint',
  QuizSubmission: 'QuizSubmission',
  TherapistBreak: 'TherapistBreak',
  AIChatMessage: 'AIChatMessage',
  AssistantConversation: 'AssistantConversation',
  AiSubscription: 'AiSubscription',
  AiConversation: 'AiConversation',
  AiAssessment: 'AiAssessment',
  Invoice: 'Invoice',
  Referrer: 'Referrer',
  ReferralVisit: 'ReferralVisit',
  ReferralConversion: 'ReferralConversion',
  DiscountCampaign: 'DiscountCampaign',
  DiscountUsage: 'DiscountUsage',
  TestMagicLink: 'TestMagicLink',
  TestDiagnosticEvent: 'TestDiagnosticEvent',
  GiftCard: 'GiftCard',
  CreditTransaction: 'CreditTransaction',
  Organisation: 'Organisation',
  OrganisationMembership: 'OrganisationMembership',
  OrganisationPurchase: 'OrganisationPurchase',
  OrganisationInvite: 'OrganisationInvite',
  BlogReview: 'BlogReview',
  AcquisitionSelfReport: 'AcquisitionSelfReport',
  MetaLead: 'MetaLead',
  ConcernCatalog: 'ConcernCatalog',
  TherapistConcern: 'TherapistConcern',
  TherapistApproach: 'TherapistApproach',
  ApproachCatalog: 'ApproachCatalog',
  TherapistQualification: 'TherapistQualification',
  TherapistPracticeSnapshot: 'TherapistPracticeSnapshot'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const AddressScalarFieldEnum = {
  id: 'id',
  street: 'street',
  city: 'city',
  postalCode: 'postalCode',
  country: 'country',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
} as const

export type AddressScalarFieldEnum = (typeof AddressScalarFieldEnum)[keyof typeof AddressScalarFieldEnum]


export const UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  role: 'role',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  creditBalance: 'creditBalance',
  geoCountry: 'geoCountry',
  geoRegion: 'geoRegion',
  geoCity: 'geoCity',
  geoLatitude: 'geoLatitude',
  geoLongitude: 'geoLongitude'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
} as const

export type AccountScalarFieldEnum = (typeof AccountScalarFieldEnum)[keyof typeof AccountScalarFieldEnum]


export const SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires',
  impersonatedByAdminId: 'impersonatedByAdminId',
  parentSessionId: 'parentSessionId',
  impersonationStartedAt: 'impersonationStartedAt',
  impersonationReason: 'impersonationReason',
  impersonationReturnTo: 'impersonationReturnTo',
  endedAt: 'endedAt'
} as const

export type SessionScalarFieldEnum = (typeof SessionScalarFieldEnum)[keyof typeof SessionScalarFieldEnum]


export const AuditLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  action: 'action',
  actorUserId: 'actorUserId',
  effectiveUserId: 'effectiveUserId',
  sessionId: 'sessionId',
  targetUserId: 'targetUserId',
  resourceType: 'resourceType',
  resourceId: 'resourceId',
  isImpersonated: 'isImpersonated',
  metadata: 'metadata'
} as const

export type AuditLogScalarFieldEnum = (typeof AuditLogScalarFieldEnum)[keyof typeof AuditLogScalarFieldEnum]


export const OneTimePurchaseScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  paymentReferenceId: 'paymentReferenceId',
  name: 'name',
  email: 'email',
  status: 'status',
  customerId: 'customerId',
  remainingSessionCredits: 'remainingSessionCredits',
  currency: 'currency',
  customerPaidAmount: 'customerPaidAmount',
  therapistBasePrice: 'therapistBasePrice',
  discountAmount: 'discountAmount',
  discountedSessionPrice: 'discountedSessionPrice',
  commissionRate: 'commissionRate',
  commissionAmount: 'commissionAmount',
  userId: 'userId',
  therapyRelationshipId: 'therapyRelationshipId'
} as const

export type OneTimePurchaseScalarFieldEnum = (typeof OneTimePurchaseScalarFieldEnum)[keyof typeof OneTimePurchaseScalarFieldEnum]


export const AttributionBridgeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  userId: 'userId',
  linkedAt: 'linkedAt',
  fingerprint: 'fingerprint',
  clickIdType: 'clickIdType',
  clickId: 'clickId',
  source: 'source',
  medium: 'medium',
  campaign: 'campaign',
  content: 'content',
  term: 'term',
  landingPath: 'landingPath',
  landingAt: 'landingAt'
} as const

export type AttributionBridgeScalarFieldEnum = (typeof AttributionBridgeScalarFieldEnum)[keyof typeof AttributionBridgeScalarFieldEnum]


export const VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
} as const

export type VerificationTokenScalarFieldEnum = (typeof VerificationTokenScalarFieldEnum)[keyof typeof VerificationTokenScalarFieldEnum]


export const ChatMessageScalarFieldEnum = {
  id: 'id',
  message: 'message',
  metadata: 'metadata',
  iv: 'iv',
  type: 'type',
  therapyRelationshipId: 'therapyRelationshipId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  senderId: 'senderId',
  receiverId: 'receiverId',
  readAt: 'readAt',
  notifiedAt: 'notifiedAt'
} as const

export type ChatMessageScalarFieldEnum = (typeof ChatMessageScalarFieldEnum)[keyof typeof ChatMessageScalarFieldEnum]


export const PatientScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  bio: 'bio',
  dateOfBirth: 'dateOfBirth',
  emergencyPerson: 'emergencyPerson',
  emergencyContact: 'emergencyContact',
  aiProfile: 'aiProfile',
  aiMemoryConsentAt: 'aiMemoryConsentAt'
} as const

export type PatientScalarFieldEnum = (typeof PatientScalarFieldEnum)[keyof typeof PatientScalarFieldEnum]


export const TherapistScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  gender: 'gender',
  languages: 'languages',
  specialties: 'specialties',
  qualifications: 'qualifications',
  bio: 'bio',
  yearsOfExperience: 'yearsOfExperience',
  title: 'title',
  contact: 'contact',
  isVerified: 'isVerified',
  qualificationCategory: 'qualificationCategory',
  payoneerEmail: 'payoneerEmail',
  defaultPrice: 'defaultPrice',
  couplesTherapyPrice: 'couplesTherapyPrice',
  defaultComissionRate: 'defaultComissionRate',
  firstSessionComission: 'firstSessionComission',
  videoIntroductionUrl: 'videoIntroductionUrl',
  isFeatured: 'isFeatured',
  aiSummary: 'aiSummary',
  paymentMethod: 'paymentMethod',
  bankAccountHolderName: 'bankAccountHolderName',
  bankIban: 'bankIban',
  bankSwiftBic: 'bankSwiftBic',
  isIncognito: 'isIncognito',
  offersIntroCall: 'offersIntroCall',
  companyId: 'companyId',
  practiceRevision: 'practiceRevision',
  practiceUpdatedAt: 'practiceUpdatedAt',
  practiceOrigin: 'practiceOrigin',
  practiceSourceHash: 'practiceSourceHash',
  practiceMethodVersion: 'practiceMethodVersion',
  languageCodes: 'languageCodes',
  aiSummarySourceHash: 'aiSummarySourceHash',
  recommendationExposureScore: 'recommendationExposureScore',
  recommendationExposureUpdatedAt: 'recommendationExposureUpdatedAt',
  individualSessionDuration: 'individualSessionDuration',
  couplesSessionDuration: 'couplesSessionDuration',
  sessionBufferMinutes: 'sessionBufferMinutes',
  bookingSlotIntervalMinutes: 'bookingSlotIntervalMinutes',
  minimumBookingLeadTime: 'minimumBookingLeadTime',
  minimumClientAge: 'minimumClientAge',
  timezone: 'timezone'
} as const

export type TherapistScalarFieldEnum = (typeof TherapistScalarFieldEnum)[keyof typeof TherapistScalarFieldEnum]


export const MinorGuardianConsentScalarFieldEnum = {
  id: 'id',
  teenUserId: 'teenUserId',
  guardianName: 'guardianName',
  guardianEmail: 'guardianEmail',
  guardianPhone: 'guardianPhone',
  guardianRelationship: 'guardianRelationship',
  teenName: 'teenName',
  teenDateOfBirth: 'teenDateOfBirth',
  teenStreet: 'teenStreet',
  teenCity: 'teenCity',
  teenPostalCode: 'teenPostalCode',
  teenCountry: 'teenCountry',
  consentTextVersion: 'consentTextVersion',
  status: 'status',
  acceptedAt: 'acceptedAt',
  revokedAt: 'revokedAt',
  revokedByUserId: 'revokedByUserId',
  revocationReason: 'revocationReason',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MinorGuardianConsentScalarFieldEnum = (typeof MinorGuardianConsentScalarFieldEnum)[keyof typeof MinorGuardianConsentScalarFieldEnum]


export const MinorGuardianConsentInviteScalarFieldEnum = {
  id: 'id',
  teenUserId: 'teenUserId',
  guardianEmail: 'guardianEmail',
  tokenHash: 'tokenHash',
  expiresAt: 'expiresAt',
  usedAt: 'usedAt',
  supersededAt: 'supersededAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MinorGuardianConsentInviteScalarFieldEnum = (typeof MinorGuardianConsentInviteScalarFieldEnum)[keyof typeof MinorGuardianConsentInviteScalarFieldEnum]


export const CompanyScalarFieldEnum = {
  id: 'id',
  name: 'name',
  vat: 'vat',
  street: 'street',
  city: 'city',
  postalCode: 'postalCode',
  country: 'country',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CompanyScalarFieldEnum = (typeof CompanyScalarFieldEnum)[keyof typeof CompanyScalarFieldEnum]


export const TherapistDocumentScalarFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  type: 'type',
  fileUrl: 'fileUrl',
  version: 'version',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TherapistDocumentScalarFieldEnum = (typeof TherapistDocumentScalarFieldEnum)[keyof typeof TherapistDocumentScalarFieldEnum]


export const TherapyRelationshipScalarFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  patientId: 'patientId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  endDate: 'endDate',
  status: 'status',
  type: 'type',
  patientsPartnerId: 'patientsPartnerId',
  price: 'price',
  comission: 'comission'
} as const

export type TherapyRelationshipScalarFieldEnum = (typeof TherapyRelationshipScalarFieldEnum)[keyof typeof TherapyRelationshipScalarFieldEnum]


export const AdditionalServiceScalarFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  therapyRelationshipId: 'therapyRelationshipId',
  name: 'name',
  paymentReferenceId: 'paymentReferenceId',
  paymentStatus: 'paymentStatus',
  currency: 'currency',
  grossAmount: 'grossAmount',
  therapistCutAmount: 'therapistCutAmount',
  paidAt: 'paidAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AdditionalServiceScalarFieldEnum = (typeof AdditionalServiceScalarFieldEnum)[keyof typeof AdditionalServiceScalarFieldEnum]


export const TherapistReportScalarFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  therapyRelationshipId: 'therapyRelationshipId',
  additionalServiceId: 'additionalServiceId',
  checkoutId: 'checkoutId',
  supersedesReportId: 'supersedesReportId',
  status: 'status',
  language: 'language',
  grossAmountCents: 'grossAmountCents',
  commissionRate: 'commissionRate',
  commissionAmountCents: 'commissionAmountCents',
  therapistNetCents: 'therapistNetCents',
  expectedDeliveryAt: 'expectedDeliveryAt',
  therapistNote: 'therapistNote',
  paymentReferenceId: 'paymentReferenceId',
  draftContent: 'draftContent',
  finalContent: 'finalContent',
  finalPdf: 'finalPdf',
  finalPdfChecksum: 'finalPdfChecksum',
  finalizedAt: 'finalizedAt',
  deliveredAt: 'deliveredAt',
  cancelledAt: 'cancelledAt',
  refundedAt: 'refundedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TherapistReportScalarFieldEnum = (typeof TherapistReportScalarFieldEnum)[keyof typeof TherapistReportScalarFieldEnum]


export const TherapistReportCheckoutScalarFieldEnum = {
  id: 'id',
  payerUserId: 'payerUserId',
  therapistId: 'therapistId',
  therapyRelationshipId: 'therapyRelationshipId',
  grossAmountCents: 'grossAmountCents',
  commissionRate: 'commissionRate',
  commissionAmountCents: 'commissionAmountCents',
  therapistNetCents: 'therapistNetCents',
  paymentReferenceId: 'paymentReferenceId',
  paidAt: 'paidAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TherapistReportCheckoutScalarFieldEnum = (typeof TherapistReportCheckoutScalarFieldEnum)[keyof typeof TherapistReportCheckoutScalarFieldEnum]


export const UserReviewScalarFieldEnum = {
  id: 'id',
  rating: 'rating',
  review: 'review',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  senderId: 'senderId'
} as const

export type UserReviewScalarFieldEnum = (typeof UserReviewScalarFieldEnum)[keyof typeof UserReviewScalarFieldEnum]


export const SessionReviewScalarFieldEnum = {
  id: 'id',
  rating: 'rating',
  review: 'review',
  identityMode: 'identityMode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sessionId: 'sessionId',
  userId: 'userId',
  senderId: 'senderId'
} as const

export type SessionReviewScalarFieldEnum = (typeof SessionReviewScalarFieldEnum)[keyof typeof SessionReviewScalarFieldEnum]


export const TherapySessionScalarFieldEnum = {
  id: 'id',
  publicId: 'publicId',
  date: 'date',
  duration: 'duration',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  status: 'status',
  billingType: 'billingType',
  sessionPurpose: 'sessionPurpose',
  isReminderSent: 'isReminderSent',
  reminderClaimedAt: 'reminderClaimedAt',
  therapistPostSessionHandledAt: 'therapistPostSessionHandledAt',
  feedbackRequestSentAt: 'feedbackRequestSentAt',
  newSessionRequestSentAt: 'newSessionRequestSentAt',
  therapyRelationshipId: 'therapyRelationshipId',
  organisationPurchaseId: 'organisationPurchaseId',
  oneTimePurchaseId: 'oneTimePurchaseId'
} as const

export type TherapySessionScalarFieldEnum = (typeof TherapySessionScalarFieldEnum)[keyof typeof TherapySessionScalarFieldEnum]


export const GoogleCalendarAccessScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  primaryCalendarId: 'primaryCalendarId'
} as const

export type GoogleCalendarAccessScalarFieldEnum = (typeof GoogleCalendarAccessScalarFieldEnum)[keyof typeof GoogleCalendarAccessScalarFieldEnum]


export const WorkingHoursScalarFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  dayOfWeek: 'dayOfWeek',
  isEnabled: 'isEnabled',
  startTime: 'startTime',
  endTime: 'endTime',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type WorkingHoursScalarFieldEnum = (typeof WorkingHoursScalarFieldEnum)[keyof typeof WorkingHoursScalarFieldEnum]


export const EarningScalarFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  sessionId: 'sessionId',
  additionalServiceId: 'additionalServiceId',
  grossAmount: 'grossAmount',
  commissionRate: 'commissionRate',
  commissionAmount: 'commissionAmount',
  netAmount: 'netAmount',
  payoutStatus: 'payoutStatus',
  payoutDate: 'payoutDate',
  createdAt: 'createdAt',
  payoutId: 'payoutId',
  invoiceId: 'invoiceId'
} as const

export type EarningScalarFieldEnum = (typeof EarningScalarFieldEnum)[keyof typeof EarningScalarFieldEnum]


export const PayoutScalarFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  totalAmount: 'totalAmount',
  month: 'month',
  status: 'status',
  payoutDate: 'payoutDate',
  createdAt: 'createdAt'
} as const

export type PayoutScalarFieldEnum = (typeof PayoutScalarFieldEnum)[keyof typeof PayoutScalarFieldEnum]


export const ComplaintScalarFieldEnum = {
  id: 'id',
  reason: 'reason',
  description: 'description',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  complainantId: 'complainantId',
  subjectId: 'subjectId',
  therapyRelationshipId: 'therapyRelationshipId'
} as const

export type ComplaintScalarFieldEnum = (typeof ComplaintScalarFieldEnum)[keyof typeof ComplaintScalarFieldEnum]


export const QuizSubmissionScalarFieldEnum = {
  id: 'id',
  email: 'email',
  answers: 'answers',
  recommendation: 'recommendation',
  generationStatus: 'generationStatus',
  generationStartedAt: 'generationStartedAt',
  generationError: 'generationError',
  newsletterOptIn: 'newsletterOptIn',
  createdAt: 'createdAt',
  quizType: 'quizType',
  source: 'source',
  therapistMatchingId: 'therapistMatchingId'
} as const

export type QuizSubmissionScalarFieldEnum = (typeof QuizSubmissionScalarFieldEnum)[keyof typeof QuizSubmissionScalarFieldEnum]


export const TherapistBreakScalarFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  startTime: 'startTime',
  endTime: 'endTime',
  reason: 'reason',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TherapistBreakScalarFieldEnum = (typeof TherapistBreakScalarFieldEnum)[keyof typeof TherapistBreakScalarFieldEnum]


export const AIChatMessageScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  message: 'message',
  role: 'role',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  therapyRelationshipId: 'therapyRelationshipId',
  conversationId: 'conversationId'
} as const

export type AIChatMessageScalarFieldEnum = (typeof AIChatMessageScalarFieldEnum)[keyof typeof AIChatMessageScalarFieldEnum]


export const AssistantConversationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  messages: 'messages',
  therapyType: 'therapyType',
  genderPreference: 'genderPreference',
  matchResultsId: 'matchResultsId',
  escalated: 'escalated',
  messageCount: 'messageCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssistantConversationScalarFieldEnum = (typeof AssistantConversationScalarFieldEnum)[keyof typeof AssistantConversationScalarFieldEnum]


export const AiSubscriptionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  duration: 'duration',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tier: 'tier',
  status: 'status',
  stripeSubscriptionId: 'stripeSubscriptionId'
} as const

export type AiSubscriptionScalarFieldEnum = (typeof AiSubscriptionScalarFieldEnum)[keyof typeof AiSubscriptionScalarFieldEnum]


export const AiConversationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  anonymousId: 'anonymousId',
  status: 'status',
  title: 'title',
  summary: 'summary',
  mood: 'mood',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AiConversationScalarFieldEnum = (typeof AiConversationScalarFieldEnum)[keyof typeof AiConversationScalarFieldEnum]


export const AiAssessmentScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  instrument: 'instrument',
  score: 'score',
  subscales: 'subscales',
  takenAt: 'takenAt',
  conversationId: 'conversationId',
  quizSubmissionId: 'quizSubmissionId'
} as const

export type AiAssessmentScalarFieldEnum = (typeof AiAssessmentScalarFieldEnum)[keyof typeof AiAssessmentScalarFieldEnum]


export const InvoiceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  invoiceNumber: 'invoiceNumber',
  mercuryEmailSentAt: 'mercuryEmailSentAt',
  month: 'month',
  year: 'year',
  currency: 'currency',
  exchangeRate: 'exchangeRate',
  exchangeRateDate: 'exchangeRateDate',
  therapistId: 'therapistId',
  payoutId: 'payoutId'
} as const

export type InvoiceScalarFieldEnum = (typeof InvoiceScalarFieldEnum)[keyof typeof InvoiceScalarFieldEnum]


export const ReferrerScalarFieldEnum = {
  id: 'id',
  email: 'email',
  name: 'name',
  bio: 'bio',
  profilePhoto: 'profilePhoto',
  socialLinks: 'socialLinks',
  personalMessage: 'personalMessage',
  referralCode: 'referralCode',
  isApproved: 'isApproved',
  isActive: 'isActive',
  commission: 'commission',
  paypalEmail: 'paypalEmail',
  payoneerEmail: 'payoneerEmail',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
} as const

export type ReferrerScalarFieldEnum = (typeof ReferrerScalarFieldEnum)[keyof typeof ReferrerScalarFieldEnum]


export const ReferralVisitScalarFieldEnum = {
  id: 'id',
  referrerId: 'referrerId',
  visitorId: 'visitorId',
  userAgent: 'userAgent',
  ipAddress: 'ipAddress',
  createdAt: 'createdAt'
} as const

export type ReferralVisitScalarFieldEnum = (typeof ReferralVisitScalarFieldEnum)[keyof typeof ReferralVisitScalarFieldEnum]


export const ReferralConversionScalarFieldEnum = {
  id: 'id',
  referrerId: 'referrerId',
  patientId: 'patientId',
  commission: 'commission',
  isPaid: 'isPaid',
  paidAt: 'paidAt',
  createdAt: 'createdAt'
} as const

export type ReferralConversionScalarFieldEnum = (typeof ReferralConversionScalarFieldEnum)[keyof typeof ReferralConversionScalarFieldEnum]


export const DiscountCampaignScalarFieldEnum = {
  id: 'id',
  name: 'name',
  code: 'code',
  discount: 'discount',
  userType: 'userType',
  maxUses: 'maxUses',
  currentUses: 'currentUses',
  validUntil: 'validUntil',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DiscountCampaignScalarFieldEnum = (typeof DiscountCampaignScalarFieldEnum)[keyof typeof DiscountCampaignScalarFieldEnum]


export const DiscountUsageScalarFieldEnum = {
  id: 'id',
  campaignId: 'campaignId',
  userId: 'userId',
  email: 'email',
  usedAt: 'usedAt'
} as const

export type DiscountUsageScalarFieldEnum = (typeof DiscountUsageScalarFieldEnum)[keyof typeof DiscountUsageScalarFieldEnum]


export const TestMagicLinkScalarFieldEnum = {
  id: 'id',
  email: 'email',
  magicLink: 'magicLink',
  createdAt: 'createdAt',
  expiresAt: 'expiresAt'
} as const

export type TestMagicLinkScalarFieldEnum = (typeof TestMagicLinkScalarFieldEnum)[keyof typeof TestMagicLinkScalarFieldEnum]


export const TestDiagnosticEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  kind: 'kind',
  debugCode: 'debugCode',
  payload: 'payload'
} as const

export type TestDiagnosticEventScalarFieldEnum = (typeof TestDiagnosticEventScalarFieldEnum)[keyof typeof TestDiagnosticEventScalarFieldEnum]


export const GiftCardScalarFieldEnum = {
  id: 'id',
  code: 'code',
  purchasedByEmail: 'purchasedByEmail',
  purchasedByName: 'purchasedByName',
  purchasedById: 'purchasedById',
  recipientEmail: 'recipientEmail',
  recipientName: 'recipientName',
  personalMessage: 'personalMessage',
  valueInEur: 'valueInEur',
  status: 'status',
  redeemedAt: 'redeemedAt',
  redeemedById: 'redeemedById',
  redemptionToken: 'redemptionToken',
  expiresAt: 'expiresAt',
  paymentId: 'paymentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GiftCardScalarFieldEnum = (typeof GiftCardScalarFieldEnum)[keyof typeof GiftCardScalarFieldEnum]


export const CreditTransactionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  amount: 'amount',
  type: 'type',
  description: 'description',
  giftCardId: 'giftCardId',
  purchaseId: 'purchaseId',
  createdAt: 'createdAt'
} as const

export type CreditTransactionScalarFieldEnum = (typeof CreditTransactionScalarFieldEnum)[keyof typeof CreditTransactionScalarFieldEnum]


export const OrganisationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  contactEmail: 'contactEmail',
  contactName: 'contactName',
  sessionBalance: 'sessionBalance',
  totalSessionsPurchased: 'totalSessionsPurchased',
  validUntil: 'validUntil',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OrganisationScalarFieldEnum = (typeof OrganisationScalarFieldEnum)[keyof typeof OrganisationScalarFieldEnum]


export const OrganisationMembershipScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  organisationId: 'organisationId',
  role: 'role',
  invitedAt: 'invitedAt',
  joinedAt: 'joinedAt'
} as const

export type OrganisationMembershipScalarFieldEnum = (typeof OrganisationMembershipScalarFieldEnum)[keyof typeof OrganisationMembershipScalarFieldEnum]


export const OrganisationPurchaseScalarFieldEnum = {
  id: 'id',
  organisationId: 'organisationId',
  sessionCount: 'sessionCount',
  totalPrice: 'totalPrice',
  sessionPrice: 'sessionPrice',
  stripePaymentId: 'stripePaymentId',
  invoiceNumber: 'invoiceNumber',
  createdAt: 'createdAt'
} as const

export type OrganisationPurchaseScalarFieldEnum = (typeof OrganisationPurchaseScalarFieldEnum)[keyof typeof OrganisationPurchaseScalarFieldEnum]


export const OrganisationInviteScalarFieldEnum = {
  id: 'id',
  organisationId: 'organisationId',
  token: 'token',
  expiresAt: 'expiresAt',
  usedAt: 'usedAt',
  usedById: 'usedById',
  createdAt: 'createdAt'
} as const

export type OrganisationInviteScalarFieldEnum = (typeof OrganisationInviteScalarFieldEnum)[keyof typeof OrganisationInviteScalarFieldEnum]


export const BlogReviewScalarFieldEnum = {
  id: 'id',
  blogSlug: 'blogSlug',
  therapistId: 'therapistId',
  status: 'status',
  comment: 'comment',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BlogReviewScalarFieldEnum = (typeof BlogReviewScalarFieldEnum)[keyof typeof BlogReviewScalarFieldEnum]


export const AcquisitionSelfReportScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  answer: 'answer',
  otherDetails: 'otherDetails',
  createdAt: 'createdAt'
} as const

export type AcquisitionSelfReportScalarFieldEnum = (typeof AcquisitionSelfReportScalarFieldEnum)[keyof typeof AcquisitionSelfReportScalarFieldEnum]


export const MetaLeadScalarFieldEnum = {
  id: 'id',
  leadgenId: 'leadgenId',
  formId: 'formId',
  adId: 'adId',
  campaignId: 'campaignId',
  emailHash: 'emailHash',
  firstName: 'firstName',
  timeOfDay: 'timeOfDay',
  consent: 'consent',
  consentText: 'consentText',
  country: 'country',
  loopsSyncedAt: 'loopsSyncedAt',
  createdAt: 'createdAt'
} as const

export type MetaLeadScalarFieldEnum = (typeof MetaLeadScalarFieldEnum)[keyof typeof MetaLeadScalarFieldEnum]


export const ConcernCatalogScalarFieldEnum = {
  key: 'key',
  label: 'label',
  definition: 'definition',
  aliases: 'aliases',
  examples: 'examples',
  active: 'active',
  updatedAt: 'updatedAt'
} as const

export type ConcernCatalogScalarFieldEnum = (typeof ConcernCatalogScalarFieldEnum)[keyof typeof ConcernCatalogScalarFieldEnum]


export const TherapistConcernScalarFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  concernKey: 'concernKey',
  tier: 'tier'
} as const

export type TherapistConcernScalarFieldEnum = (typeof TherapistConcernScalarFieldEnum)[keyof typeof TherapistConcernScalarFieldEnum]


export const TherapistApproachScalarFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  key: 'key'
} as const

export type TherapistApproachScalarFieldEnum = (typeof TherapistApproachScalarFieldEnum)[keyof typeof TherapistApproachScalarFieldEnum]


export const ApproachCatalogScalarFieldEnum = {
  key: 'key',
  label: 'label',
  description: 'description',
  example: 'example',
  updatedAt: 'updatedAt'
} as const

export type ApproachCatalogScalarFieldEnum = (typeof ApproachCatalogScalarFieldEnum)[keyof typeof ApproachCatalogScalarFieldEnum]


export const TherapistQualificationScalarFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  originalText: 'originalText',
  category: 'category',
  approachKey: 'approachKey',
  trainingStatus: 'trainingStatus'
} as const

export type TherapistQualificationScalarFieldEnum = (typeof TherapistQualificationScalarFieldEnum)[keyof typeof TherapistQualificationScalarFieldEnum]


export const TherapistPracticeSnapshotScalarFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  sourceHash: 'sourceHash',
  source: 'source',
  reconciliation: 'reconciliation',
  methodVersion: 'methodVersion',
  createdAt: 'createdAt'
} as const

export type TherapistPracticeSnapshotScalarFieldEnum = (typeof TherapistPracticeSnapshotScalarFieldEnum)[keyof typeof TherapistPracticeSnapshotScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const AddressOrderByRelevanceFieldEnum = {
  street: 'street',
  city: 'city',
  postalCode: 'postalCode',
  country: 'country',
  userId: 'userId'
} as const

export type AddressOrderByRelevanceFieldEnum = (typeof AddressOrderByRelevanceFieldEnum)[keyof typeof AddressOrderByRelevanceFieldEnum]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const UserOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  image: 'image',
  geoCountry: 'geoCountry',
  geoRegion: 'geoRegion',
  geoCity: 'geoCity',
  geoLatitude: 'geoLatitude',
  geoLongitude: 'geoLongitude'
} as const

export type UserOrderByRelevanceFieldEnum = (typeof UserOrderByRelevanceFieldEnum)[keyof typeof UserOrderByRelevanceFieldEnum]


export const AccountOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
} as const

export type AccountOrderByRelevanceFieldEnum = (typeof AccountOrderByRelevanceFieldEnum)[keyof typeof AccountOrderByRelevanceFieldEnum]


export const SessionOrderByRelevanceFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  impersonatedByAdminId: 'impersonatedByAdminId',
  parentSessionId: 'parentSessionId',
  impersonationReason: 'impersonationReason',
  impersonationReturnTo: 'impersonationReturnTo'
} as const

export type SessionOrderByRelevanceFieldEnum = (typeof SessionOrderByRelevanceFieldEnum)[keyof typeof SessionOrderByRelevanceFieldEnum]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]


export const AuditLogOrderByRelevanceFieldEnum = {
  id: 'id',
  action: 'action',
  actorUserId: 'actorUserId',
  effectiveUserId: 'effectiveUserId',
  sessionId: 'sessionId',
  targetUserId: 'targetUserId',
  resourceType: 'resourceType',
  resourceId: 'resourceId'
} as const

export type AuditLogOrderByRelevanceFieldEnum = (typeof AuditLogOrderByRelevanceFieldEnum)[keyof typeof AuditLogOrderByRelevanceFieldEnum]


export const OneTimePurchaseOrderByRelevanceFieldEnum = {
  paymentReferenceId: 'paymentReferenceId',
  name: 'name',
  email: 'email',
  status: 'status',
  customerId: 'customerId',
  currency: 'currency',
  userId: 'userId',
  therapyRelationshipId: 'therapyRelationshipId'
} as const

export type OneTimePurchaseOrderByRelevanceFieldEnum = (typeof OneTimePurchaseOrderByRelevanceFieldEnum)[keyof typeof OneTimePurchaseOrderByRelevanceFieldEnum]


export const AttributionBridgeOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  fingerprint: 'fingerprint',
  clickIdType: 'clickIdType',
  clickId: 'clickId',
  source: 'source',
  medium: 'medium',
  campaign: 'campaign',
  content: 'content',
  term: 'term',
  landingPath: 'landingPath'
} as const

export type AttributionBridgeOrderByRelevanceFieldEnum = (typeof AttributionBridgeOrderByRelevanceFieldEnum)[keyof typeof AttributionBridgeOrderByRelevanceFieldEnum]


export const VerificationTokenOrderByRelevanceFieldEnum = {
  identifier: 'identifier',
  token: 'token'
} as const

export type VerificationTokenOrderByRelevanceFieldEnum = (typeof VerificationTokenOrderByRelevanceFieldEnum)[keyof typeof VerificationTokenOrderByRelevanceFieldEnum]


export const ChatMessageOrderByRelevanceFieldEnum = {
  message: 'message',
  iv: 'iv',
  therapyRelationshipId: 'therapyRelationshipId',
  senderId: 'senderId',
  receiverId: 'receiverId'
} as const

export type ChatMessageOrderByRelevanceFieldEnum = (typeof ChatMessageOrderByRelevanceFieldEnum)[keyof typeof ChatMessageOrderByRelevanceFieldEnum]


export const PatientOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  bio: 'bio',
  emergencyPerson: 'emergencyPerson',
  emergencyContact: 'emergencyContact'
} as const

export type PatientOrderByRelevanceFieldEnum = (typeof PatientOrderByRelevanceFieldEnum)[keyof typeof PatientOrderByRelevanceFieldEnum]


export const TherapistOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  slug: 'slug',
  languages: 'languages',
  specialties: 'specialties',
  qualifications: 'qualifications',
  bio: 'bio',
  title: 'title',
  contact: 'contact',
  qualificationCategory: 'qualificationCategory',
  payoneerEmail: 'payoneerEmail',
  videoIntroductionUrl: 'videoIntroductionUrl',
  aiSummary: 'aiSummary',
  paymentMethod: 'paymentMethod',
  bankAccountHolderName: 'bankAccountHolderName',
  bankIban: 'bankIban',
  bankSwiftBic: 'bankSwiftBic',
  companyId: 'companyId',
  practiceOrigin: 'practiceOrigin',
  practiceSourceHash: 'practiceSourceHash',
  practiceMethodVersion: 'practiceMethodVersion',
  languageCodes: 'languageCodes',
  aiSummarySourceHash: 'aiSummarySourceHash',
  timezone: 'timezone'
} as const

export type TherapistOrderByRelevanceFieldEnum = (typeof TherapistOrderByRelevanceFieldEnum)[keyof typeof TherapistOrderByRelevanceFieldEnum]


export const MinorGuardianConsentOrderByRelevanceFieldEnum = {
  id: 'id',
  teenUserId: 'teenUserId',
  guardianName: 'guardianName',
  guardianEmail: 'guardianEmail',
  guardianPhone: 'guardianPhone',
  teenName: 'teenName',
  teenStreet: 'teenStreet',
  teenCity: 'teenCity',
  teenPostalCode: 'teenPostalCode',
  teenCountry: 'teenCountry',
  consentTextVersion: 'consentTextVersion',
  revokedByUserId: 'revokedByUserId',
  revocationReason: 'revocationReason',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent'
} as const

export type MinorGuardianConsentOrderByRelevanceFieldEnum = (typeof MinorGuardianConsentOrderByRelevanceFieldEnum)[keyof typeof MinorGuardianConsentOrderByRelevanceFieldEnum]


export const MinorGuardianConsentInviteOrderByRelevanceFieldEnum = {
  id: 'id',
  teenUserId: 'teenUserId',
  guardianEmail: 'guardianEmail',
  tokenHash: 'tokenHash'
} as const

export type MinorGuardianConsentInviteOrderByRelevanceFieldEnum = (typeof MinorGuardianConsentInviteOrderByRelevanceFieldEnum)[keyof typeof MinorGuardianConsentInviteOrderByRelevanceFieldEnum]


export const CompanyOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  vat: 'vat',
  street: 'street',
  city: 'city',
  postalCode: 'postalCode',
  country: 'country'
} as const

export type CompanyOrderByRelevanceFieldEnum = (typeof CompanyOrderByRelevanceFieldEnum)[keyof typeof CompanyOrderByRelevanceFieldEnum]


export const TherapistDocumentOrderByRelevanceFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  fileUrl: 'fileUrl',
  version: 'version',
  content: 'content'
} as const

export type TherapistDocumentOrderByRelevanceFieldEnum = (typeof TherapistDocumentOrderByRelevanceFieldEnum)[keyof typeof TherapistDocumentOrderByRelevanceFieldEnum]


export const TherapyRelationshipOrderByRelevanceFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  patientId: 'patientId',
  patientsPartnerId: 'patientsPartnerId'
} as const

export type TherapyRelationshipOrderByRelevanceFieldEnum = (typeof TherapyRelationshipOrderByRelevanceFieldEnum)[keyof typeof TherapyRelationshipOrderByRelevanceFieldEnum]


export const AdditionalServiceOrderByRelevanceFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  therapyRelationshipId: 'therapyRelationshipId',
  name: 'name',
  paymentReferenceId: 'paymentReferenceId',
  currency: 'currency'
} as const

export type AdditionalServiceOrderByRelevanceFieldEnum = (typeof AdditionalServiceOrderByRelevanceFieldEnum)[keyof typeof AdditionalServiceOrderByRelevanceFieldEnum]


export const TherapistReportOrderByRelevanceFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  therapyRelationshipId: 'therapyRelationshipId',
  additionalServiceId: 'additionalServiceId',
  checkoutId: 'checkoutId',
  supersedesReportId: 'supersedesReportId',
  therapistNote: 'therapistNote',
  paymentReferenceId: 'paymentReferenceId',
  finalPdfChecksum: 'finalPdfChecksum'
} as const

export type TherapistReportOrderByRelevanceFieldEnum = (typeof TherapistReportOrderByRelevanceFieldEnum)[keyof typeof TherapistReportOrderByRelevanceFieldEnum]


export const TherapistReportCheckoutOrderByRelevanceFieldEnum = {
  id: 'id',
  payerUserId: 'payerUserId',
  therapistId: 'therapistId',
  therapyRelationshipId: 'therapyRelationshipId',
  paymentReferenceId: 'paymentReferenceId'
} as const

export type TherapistReportCheckoutOrderByRelevanceFieldEnum = (typeof TherapistReportCheckoutOrderByRelevanceFieldEnum)[keyof typeof TherapistReportCheckoutOrderByRelevanceFieldEnum]


export const UserReviewOrderByRelevanceFieldEnum = {
  review: 'review',
  userId: 'userId',
  senderId: 'senderId'
} as const

export type UserReviewOrderByRelevanceFieldEnum = (typeof UserReviewOrderByRelevanceFieldEnum)[keyof typeof UserReviewOrderByRelevanceFieldEnum]


export const SessionReviewOrderByRelevanceFieldEnum = {
  review: 'review',
  userId: 'userId',
  senderId: 'senderId'
} as const

export type SessionReviewOrderByRelevanceFieldEnum = (typeof SessionReviewOrderByRelevanceFieldEnum)[keyof typeof SessionReviewOrderByRelevanceFieldEnum]


export const TherapySessionOrderByRelevanceFieldEnum = {
  publicId: 'publicId',
  notes: 'notes',
  therapyRelationshipId: 'therapyRelationshipId',
  organisationPurchaseId: 'organisationPurchaseId'
} as const

export type TherapySessionOrderByRelevanceFieldEnum = (typeof TherapySessionOrderByRelevanceFieldEnum)[keyof typeof TherapySessionOrderByRelevanceFieldEnum]


export const GoogleCalendarAccessOrderByRelevanceFieldEnum = {
  userId: 'userId',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  primaryCalendarId: 'primaryCalendarId'
} as const

export type GoogleCalendarAccessOrderByRelevanceFieldEnum = (typeof GoogleCalendarAccessOrderByRelevanceFieldEnum)[keyof typeof GoogleCalendarAccessOrderByRelevanceFieldEnum]


export const WorkingHoursOrderByRelevanceFieldEnum = {
  therapistId: 'therapistId',
  startTime: 'startTime',
  endTime: 'endTime'
} as const

export type WorkingHoursOrderByRelevanceFieldEnum = (typeof WorkingHoursOrderByRelevanceFieldEnum)[keyof typeof WorkingHoursOrderByRelevanceFieldEnum]


export const EarningOrderByRelevanceFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  additionalServiceId: 'additionalServiceId',
  payoutId: 'payoutId',
  invoiceId: 'invoiceId'
} as const

export type EarningOrderByRelevanceFieldEnum = (typeof EarningOrderByRelevanceFieldEnum)[keyof typeof EarningOrderByRelevanceFieldEnum]


export const PayoutOrderByRelevanceFieldEnum = {
  id: 'id',
  therapistId: 'therapistId'
} as const

export type PayoutOrderByRelevanceFieldEnum = (typeof PayoutOrderByRelevanceFieldEnum)[keyof typeof PayoutOrderByRelevanceFieldEnum]


export const ComplaintOrderByRelevanceFieldEnum = {
  id: 'id',
  reason: 'reason',
  description: 'description',
  complainantId: 'complainantId',
  subjectId: 'subjectId',
  therapyRelationshipId: 'therapyRelationshipId'
} as const

export type ComplaintOrderByRelevanceFieldEnum = (typeof ComplaintOrderByRelevanceFieldEnum)[keyof typeof ComplaintOrderByRelevanceFieldEnum]


export const QuizSubmissionOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  generationError: 'generationError',
  quizType: 'quizType',
  source: 'source',
  therapistMatchingId: 'therapistMatchingId'
} as const

export type QuizSubmissionOrderByRelevanceFieldEnum = (typeof QuizSubmissionOrderByRelevanceFieldEnum)[keyof typeof QuizSubmissionOrderByRelevanceFieldEnum]


export const TherapistBreakOrderByRelevanceFieldEnum = {
  therapistId: 'therapistId',
  reason: 'reason'
} as const

export type TherapistBreakOrderByRelevanceFieldEnum = (typeof TherapistBreakOrderByRelevanceFieldEnum)[keyof typeof TherapistBreakOrderByRelevanceFieldEnum]


export const AIChatMessageOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  message: 'message',
  therapyRelationshipId: 'therapyRelationshipId',
  conversationId: 'conversationId'
} as const

export type AIChatMessageOrderByRelevanceFieldEnum = (typeof AIChatMessageOrderByRelevanceFieldEnum)[keyof typeof AIChatMessageOrderByRelevanceFieldEnum]


export const AssistantConversationOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  therapyType: 'therapyType',
  genderPreference: 'genderPreference',
  matchResultsId: 'matchResultsId'
} as const

export type AssistantConversationOrderByRelevanceFieldEnum = (typeof AssistantConversationOrderByRelevanceFieldEnum)[keyof typeof AssistantConversationOrderByRelevanceFieldEnum]


export const AiSubscriptionOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  duration: 'duration',
  stripeSubscriptionId: 'stripeSubscriptionId'
} as const

export type AiSubscriptionOrderByRelevanceFieldEnum = (typeof AiSubscriptionOrderByRelevanceFieldEnum)[keyof typeof AiSubscriptionOrderByRelevanceFieldEnum]


export const AiConversationOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  anonymousId: 'anonymousId',
  title: 'title',
  summary: 'summary'
} as const

export type AiConversationOrderByRelevanceFieldEnum = (typeof AiConversationOrderByRelevanceFieldEnum)[keyof typeof AiConversationOrderByRelevanceFieldEnum]


export const AiAssessmentOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  instrument: 'instrument',
  conversationId: 'conversationId',
  quizSubmissionId: 'quizSubmissionId'
} as const

export type AiAssessmentOrderByRelevanceFieldEnum = (typeof AiAssessmentOrderByRelevanceFieldEnum)[keyof typeof AiAssessmentOrderByRelevanceFieldEnum]


export const InvoiceOrderByRelevanceFieldEnum = {
  id: 'id',
  invoiceNumber: 'invoiceNumber',
  currency: 'currency',
  therapistId: 'therapistId',
  payoutId: 'payoutId'
} as const

export type InvoiceOrderByRelevanceFieldEnum = (typeof InvoiceOrderByRelevanceFieldEnum)[keyof typeof InvoiceOrderByRelevanceFieldEnum]


export const ReferrerOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  name: 'name',
  bio: 'bio',
  profilePhoto: 'profilePhoto',
  personalMessage: 'personalMessage',
  referralCode: 'referralCode',
  paypalEmail: 'paypalEmail',
  payoneerEmail: 'payoneerEmail',
  userId: 'userId'
} as const

export type ReferrerOrderByRelevanceFieldEnum = (typeof ReferrerOrderByRelevanceFieldEnum)[keyof typeof ReferrerOrderByRelevanceFieldEnum]


export const ReferralVisitOrderByRelevanceFieldEnum = {
  id: 'id',
  referrerId: 'referrerId',
  visitorId: 'visitorId',
  userAgent: 'userAgent',
  ipAddress: 'ipAddress'
} as const

export type ReferralVisitOrderByRelevanceFieldEnum = (typeof ReferralVisitOrderByRelevanceFieldEnum)[keyof typeof ReferralVisitOrderByRelevanceFieldEnum]


export const ReferralConversionOrderByRelevanceFieldEnum = {
  id: 'id',
  referrerId: 'referrerId',
  patientId: 'patientId'
} as const

export type ReferralConversionOrderByRelevanceFieldEnum = (typeof ReferralConversionOrderByRelevanceFieldEnum)[keyof typeof ReferralConversionOrderByRelevanceFieldEnum]


export const DiscountCampaignOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  code: 'code'
} as const

export type DiscountCampaignOrderByRelevanceFieldEnum = (typeof DiscountCampaignOrderByRelevanceFieldEnum)[keyof typeof DiscountCampaignOrderByRelevanceFieldEnum]


export const DiscountUsageOrderByRelevanceFieldEnum = {
  id: 'id',
  campaignId: 'campaignId',
  userId: 'userId',
  email: 'email'
} as const

export type DiscountUsageOrderByRelevanceFieldEnum = (typeof DiscountUsageOrderByRelevanceFieldEnum)[keyof typeof DiscountUsageOrderByRelevanceFieldEnum]


export const TestMagicLinkOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  magicLink: 'magicLink'
} as const

export type TestMagicLinkOrderByRelevanceFieldEnum = (typeof TestMagicLinkOrderByRelevanceFieldEnum)[keyof typeof TestMagicLinkOrderByRelevanceFieldEnum]


export const TestDiagnosticEventOrderByRelevanceFieldEnum = {
  id: 'id',
  kind: 'kind',
  debugCode: 'debugCode'
} as const

export type TestDiagnosticEventOrderByRelevanceFieldEnum = (typeof TestDiagnosticEventOrderByRelevanceFieldEnum)[keyof typeof TestDiagnosticEventOrderByRelevanceFieldEnum]


export const GiftCardOrderByRelevanceFieldEnum = {
  id: 'id',
  code: 'code',
  purchasedByEmail: 'purchasedByEmail',
  purchasedByName: 'purchasedByName',
  purchasedById: 'purchasedById',
  recipientEmail: 'recipientEmail',
  recipientName: 'recipientName',
  personalMessage: 'personalMessage',
  redeemedById: 'redeemedById',
  redemptionToken: 'redemptionToken',
  paymentId: 'paymentId'
} as const

export type GiftCardOrderByRelevanceFieldEnum = (typeof GiftCardOrderByRelevanceFieldEnum)[keyof typeof GiftCardOrderByRelevanceFieldEnum]


export const CreditTransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  description: 'description',
  giftCardId: 'giftCardId'
} as const

export type CreditTransactionOrderByRelevanceFieldEnum = (typeof CreditTransactionOrderByRelevanceFieldEnum)[keyof typeof CreditTransactionOrderByRelevanceFieldEnum]


export const OrganisationOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  contactEmail: 'contactEmail',
  contactName: 'contactName'
} as const

export type OrganisationOrderByRelevanceFieldEnum = (typeof OrganisationOrderByRelevanceFieldEnum)[keyof typeof OrganisationOrderByRelevanceFieldEnum]


export const OrganisationMembershipOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  organisationId: 'organisationId'
} as const

export type OrganisationMembershipOrderByRelevanceFieldEnum = (typeof OrganisationMembershipOrderByRelevanceFieldEnum)[keyof typeof OrganisationMembershipOrderByRelevanceFieldEnum]


export const OrganisationPurchaseOrderByRelevanceFieldEnum = {
  id: 'id',
  organisationId: 'organisationId',
  stripePaymentId: 'stripePaymentId',
  invoiceNumber: 'invoiceNumber'
} as const

export type OrganisationPurchaseOrderByRelevanceFieldEnum = (typeof OrganisationPurchaseOrderByRelevanceFieldEnum)[keyof typeof OrganisationPurchaseOrderByRelevanceFieldEnum]


export const OrganisationInviteOrderByRelevanceFieldEnum = {
  id: 'id',
  organisationId: 'organisationId',
  token: 'token',
  usedById: 'usedById'
} as const

export type OrganisationInviteOrderByRelevanceFieldEnum = (typeof OrganisationInviteOrderByRelevanceFieldEnum)[keyof typeof OrganisationInviteOrderByRelevanceFieldEnum]


export const BlogReviewOrderByRelevanceFieldEnum = {
  id: 'id',
  blogSlug: 'blogSlug',
  therapistId: 'therapistId',
  comment: 'comment'
} as const

export type BlogReviewOrderByRelevanceFieldEnum = (typeof BlogReviewOrderByRelevanceFieldEnum)[keyof typeof BlogReviewOrderByRelevanceFieldEnum]


export const AcquisitionSelfReportOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  answer: 'answer',
  otherDetails: 'otherDetails'
} as const

export type AcquisitionSelfReportOrderByRelevanceFieldEnum = (typeof AcquisitionSelfReportOrderByRelevanceFieldEnum)[keyof typeof AcquisitionSelfReportOrderByRelevanceFieldEnum]


export const MetaLeadOrderByRelevanceFieldEnum = {
  id: 'id',
  leadgenId: 'leadgenId',
  formId: 'formId',
  adId: 'adId',
  campaignId: 'campaignId',
  emailHash: 'emailHash',
  firstName: 'firstName',
  timeOfDay: 'timeOfDay',
  consentText: 'consentText',
  country: 'country'
} as const

export type MetaLeadOrderByRelevanceFieldEnum = (typeof MetaLeadOrderByRelevanceFieldEnum)[keyof typeof MetaLeadOrderByRelevanceFieldEnum]


export const ConcernCatalogOrderByRelevanceFieldEnum = {
  key: 'key',
  label: 'label',
  definition: 'definition',
  aliases: 'aliases',
  examples: 'examples'
} as const

export type ConcernCatalogOrderByRelevanceFieldEnum = (typeof ConcernCatalogOrderByRelevanceFieldEnum)[keyof typeof ConcernCatalogOrderByRelevanceFieldEnum]


export const TherapistConcernOrderByRelevanceFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  concernKey: 'concernKey'
} as const

export type TherapistConcernOrderByRelevanceFieldEnum = (typeof TherapistConcernOrderByRelevanceFieldEnum)[keyof typeof TherapistConcernOrderByRelevanceFieldEnum]


export const TherapistApproachOrderByRelevanceFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  key: 'key'
} as const

export type TherapistApproachOrderByRelevanceFieldEnum = (typeof TherapistApproachOrderByRelevanceFieldEnum)[keyof typeof TherapistApproachOrderByRelevanceFieldEnum]


export const ApproachCatalogOrderByRelevanceFieldEnum = {
  key: 'key',
  label: 'label',
  description: 'description',
  example: 'example'
} as const

export type ApproachCatalogOrderByRelevanceFieldEnum = (typeof ApproachCatalogOrderByRelevanceFieldEnum)[keyof typeof ApproachCatalogOrderByRelevanceFieldEnum]


export const TherapistQualificationOrderByRelevanceFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  originalText: 'originalText',
  category: 'category',
  approachKey: 'approachKey'
} as const

export type TherapistQualificationOrderByRelevanceFieldEnum = (typeof TherapistQualificationOrderByRelevanceFieldEnum)[keyof typeof TherapistQualificationOrderByRelevanceFieldEnum]


export const TherapistPracticeSnapshotOrderByRelevanceFieldEnum = {
  id: 'id',
  therapistId: 'therapistId',
  sourceHash: 'sourceHash',
  methodVersion: 'methodVersion'
} as const

export type TherapistPracticeSnapshotOrderByRelevanceFieldEnum = (typeof TherapistPracticeSnapshotOrderByRelevanceFieldEnum)[keyof typeof TherapistPracticeSnapshotOrderByRelevanceFieldEnum]

